// @flow
import styled from 'styled-components'
import { oedu_white } from '../../styles/base'
import { Layout, Icon, Modal } from 'antd'
const { Header, Sider } = Layout

export const MainLayout = styled(Layout)`
  height: 100%;
  min-height: 100vh;
  
  .trad-btn{
    writing-mode: vertical-lr;
   -webkit-writing-mode: vertical-lr;
   -ms-writing-mode: vertical-lr;
    position: fixed;
    z-index: 999;
    right: 0;
    width: 10px;
    font-size: 11px;
    padding: 5px 10px;
    height: 120px;
    top: 89px;
    border-radius: 0;
  }
  .trad-btn-hide{
    z-index: 9;
  }
  .kYZkfc{
      margin: 25px 0px;
  }
  .btn-txt{
      writing-mode: vertical-lr;
      -webkit-writing-mode: vertical-lr;
      -ms-writing-mode: vertical-lr;
      unicode-bidi: bidi-override;
      direction: ltr;
    
      letter-spacing: 3px;
      text-align: center;
      margin-left: -9px;
  }
  .hide { 
    display: none;
  }
  .show { 
    display: block;
  }
  .trades-slider { 
    position: fixed;
    right: 0;
    z-index: 999;
    top: 89px;
    border: solid 1px #3190ff;
    background: #021529;
    width:18%;
    
    .ant-layout-content { 
      background: inherit;
    }
    
    &.pinned {
      position: fixed;
      right: 0;
      top: 89px;
    }
  }
  .dock-header {
    top:0px;
    padding:5px;
    height:30px;
    width:100%;
    background: #3190ff;
    color: #fff;
  }
  .dock-header > *{
     margin: 0px 5px 5px 0px;
   }
  .dock-title {
    vertical-align: middle;
    font-size:12px;
    float:left;
  }
  .dock-Pin{
    float:right;
    cursor: pointer;
  }
  
  .min-Size{
     min-height: calc(100vh - 125px);
  }
  .ant-layout-footer{
    background: #3190ff;
    padding: 10px 0px 10px 0px;
    color: #fff;
    font-size: 14px;
    text-align: center;
  }
  .footer {
    a {
      color: #fff;
      text-decoration: none;
    }
  }
`

export const HeaderLogo = styled.section`
  color: ${oedu_white};
  font-size: 26px;
  font-weight: 300;
  height: 32px;
  letter-spacing: 1.5px;
  margin: 16px;
  text-align: center;
  position: absolute;
`

export const LoggedOutHeaderLogo = styled.section`
  color: ${oedu_white};
  font-size: 26px;
  font-weight: 300;
  height: 32px;
  letter-spacing: 1.5px;
  text-align: center;
  
  & a { 
    text-decoration: none;
  }
`

export const MainHeader = styled(Header)`
  background: ${oedu_white} !important;
  color: #1890ff;
  display: flex;
  font-size: 15px;
  font-weight: 400;
  justify-content: space-between;
  padding: 0 !important;
  & span, a {
    color: #797c7e;
    letter-spacing: 1px;
  }
  & a {
    padding: 0 24px;
  }
`

export const LoggedOutMain = styled(Header)`
  background: #021529;
  color: #1890ff;
  display: flex;
  font-size: 15px;
  font-weight: 400;
  justify-content: space-between;
  padding: 0;
  & span, a {
    color: #797c7e;
    letter-spacing: 1px;
  }
  & a {
    padding: 0 24px;
    text-decoration: none;
  }
  & .right-login {
   margin-right: 10px;
  }
`

export const HeaderIcon = styled(Icon)`
  color: #212529;
  cursor: pointer;
  font-size: 18px;
  line-height: 3;
  padding: 10px 25px;
  transition: color .3s;
`

export const StyledSider = styled(Sider)`
  box-shadow: rgba(0, 21, 41, 0.35) 2px 0px 6px;
`

export const UserMenuItem = styled.span`
  letter-spacing: .3px;
  padding-left: 10px;
`

export const StyleSpan = styled.span`
    letter-spacing: .3px;
    margin-right: 10px;
    
    button { 
      font-size: 12px;
      span {
       color: #fff;
      }
    }
    &.open {
      button {
        background: #6cb36c;
      }
    }
    &.closed {
      button {
        background: #f97777;
      }
    }
`

export const StyledLogHeader = styled.div`
  width: 100%;
  float: left;
  
  > div { 
    height: 100%;
    max-width: 600px;
    margin: 0 auto;
    
    h6 { 
      float: left;
      padding-top: 16px;
      color: rgba(0,0,0,.65);
      font-size: 12px;
      
      small {
        font-size: 16px;
      }
    }
    
    svg { 
      float: left;
      margin-top: 10px;
      margin-left: 5px;
    }    
  }
  
  .positive { 
    color: green;
  }
  .negative { 
    color: red;
  }
  .black { 
    color: rgba(0,0,0,.65);
  }
`

export const ResetPassModel = styled(Modal)`
  .ant-btn{
     width: 73px !important;
  }
  // .ant-modal-footer{
  //     border-top: 0px;
  //     padding: 0px;
  //     text-align: right;
  // }
  //
  // .model-footer{
  //     border-top: 2px solid #e8e8e8;
  //     padding: 10px 16px;
  //     text-align: right;
  //     border-radius: 0 0 4px 4px;
  // }
`

export const LogoutLayout = styled(Layout)`
  .ant-card-wider-padding {
    min-height: 82vh;
  }
`


// WEBPACK FOOTER //
// ./src/components/layout-main/style.js